import { ModalContentToggler } from '@components'

import { ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { useQueryParams } from '../../../../hooks/useQueryParams'
import { useOpenBankingAccounts } from '../../hooks/useOpenBankingAccounts'
import { openBankingAutoConnectModalSteps } from './constants/openBankingAutoConnectModalSteps'
import { OpenBankingAutoConnectContextProvider } from './contexts/openBankingAutoConnectContext'
import { OpenBankingAutoConnectModalSteps } from './enums/openBankingAutoConnectModalSteps'

interface OpenBankingAutoConnectModalProps extends ModalProps {
  initialState?: OpenBankingAutoConnectModalSteps
}

export const OpenBankingAutoConnectModalComponent = ({
  initialState,
  ...props
}: OpenBankingAutoConnectModalProps): ReactElement => {
  const { openBankingAccounts } = useOpenBankingAccounts()
  const [queryParams, setQueryParams] = useQueryParams({
    defaultQuery: { success: undefined, connectionId: undefined },
    withDefaultQueryInUrl: false,
  })

  const removeQueryParams = useCallback(() => {
    setQueryParams({ success: undefined, connectionId: undefined })
  }, [setQueryParams])

  const targetAccountIds =
    openBankingAccounts
      ?.filter((account) => account.shouldAutoConnect && account.connection.id === queryParams.connectionId)
      .map((account) => account.id) ?? []

  return (
    <OpenBankingAutoConnectContextProvider
      modalId={props.id}
      removeQueryParams={removeQueryParams}
      targetAccountIds={targetAccountIds}
    >
      <ModalContentToggler
        initialState={initialState ?? OpenBankingAutoConnectModalSteps.Loading}
        states={openBankingAutoConnectModalSteps}
        withTransition={false}
        size="s"
        closable={false}
        {...props}
      />
    </OpenBankingAutoConnectContextProvider>
  )
}

export const OpenBankingAutoConnectModal = withModalConditionalRender(OpenBankingAutoConnectModalComponent)
